module.exports = __webpack_public_path__ + "media/images/logos/mastercard-c012fc56d892d6a7cf89d251e5dfbe74.svg";